import "./style.scss";
import { useEffect, useState } from "react";
import PopupHeader from "../../PopupHeader";
import PopupSidebar, { SidebarOption } from "@builder/components/app/Popup/PopupSidebar";
import ActionSelectors from "@builder/components/app/Popup/popups/Actions/ActionSelectors";
import { useDispatch } from "react-redux";
import { setIsAutomation } from "@builder/store/slices/popupSlice";
import { useTranslation } from "react-i18next";

const Actions: React.FC = () => {
    //Sidebar Tab Options
    const [tabs, setTabs] = useState<SidebarOption[]>([
        { label: "Manually-triggered actions", value: "actions", checked: true },
        { label: "Auto-triggered actions", value: "automations", checked: false, premiumTag: true }
    ]);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [searchInput, setSearchInput] = useState<string>("");
    const handleSearchInput = (e: React.FormEvent<HTMLInputElement>) => {
        setSearchInput(e.currentTarget.value);
    };

    const tabIndex = {
        actions: 0,
        automations: 1
    };

    const tabCallback = (options: SidebarOption[]) => {
        setTabs(options);
    };

    useEffect(() => {
        if (tabs[tabIndex.automations].checked) {
            dispatch(setIsAutomation(true));
        } else {
            dispatch(setIsAutomation(false));
        }
    }, [tabs]);

    return (
        <div className="link-selector">
            <PopupHeader src="/actions-icon.svg" title="Actions">
                <div className="search-action-wrapepr">
                    {searchInput ? (
                        <button onClick={() => setSearchInput("")}>
                            <img className="cancel" src="/x-icon-dark.svg" alt="" />
                        </button>
                    ) : (
                        <img className="search" src="/search-icon.svg" alt="" />
                    )}
                    <input type="text" value={searchInput} placeholder={t("popup.popupHeader.Search for actions")} onInput={handleSearchInput} />
                </div>
            </PopupHeader>
            <div className="link-selector-body">
                <div className="left-column">
                    <PopupSidebar name="actionsSelectorTab" options={tabs} callback={tabCallback} />
                </div>
                <div className="right-column">
                    {tabs[tabIndex.actions].checked && <ActionSelectors searchInput={
                        searchInput
                    }/>}
                    {tabs[tabIndex.automations].checked && <ActionSelectors searchInput={
                        searchInput
                    }/>}
                </div>
            </div>
        </div>
    );
};

export default Actions;
